import styled from "styled-components";
import PropertyDetailsMap from "../PropertyDetails/PropertyDetails.Map";
import ListingPrice from "../Util/ListingPrice";

const TemplatePDFstyle = styled.div`
  display: none;

  .containerPDF {
    visibility: hidden;
    padding: 0px 55px;
    width: 1440px;
    background-color: white;
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
  }
  .template_pdf_desc_container {
    padding-top: 45px;
  }
  .template_logo {
    width: 1440px;
    position: absolute;
    left: 0%;
    right: 0%;
    top: 2%;
    bottom: 0%;
    opacity: 30%;
  }
  .template_pdf_divider {
    border-bottom: 1px solid var(--primary-grey-200);
  }
  .template_description_sale {
    width: 61px;
    height: 32px;
    background-color: #ddb367;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 16px;
    padding-left: 16px;
    border-radius: 100px;
    color: white;
    font-size: 12px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 800;
    line-height: 16px;
    text-transform: uppercase;
  }
  .template_description_type_house {
    padding-left: 8px;
    color: #5e676f;
    font-style: normal;
    font-size: 16px;
    font-family: "Lato";
    font-weight: 400;
    display: flex;
    align-items: center;
    text-transform: capitalize;
  }
  .small_label_location_name {
    width: 1328px;
    height: 40px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: #272a2d;
    margin-bottom: 8px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .small_label_price {
    width: 1328px;
    height: 43px;
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    color: #3a7c8a;
  }
  .small_label {
    color: #323a41;
    font-size: 32px;
  }
  .template_pdf_location_icon {
    padding-right: 13px;
    padding-top: 16px;
  }
  .template_pdf_location_address {
    width: 524px;
    height: 24px;
    font-family: "Nunito Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    color: #9e8e75;
    padding-top: 8px;
  }
  .template_pdf_images_container {
    padding-bottom: 20px;
  }
  .template_pdf_description_icon_container {
    padding-top: 20px;
  }
  .template_pdf_label_details_container {
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .template_pdf_label_title_details {
    font-family: "Lato";
    font-style: normal;
    font-weight: 700;
    font-size: 24px;
    line-height: 32px;
    color: #323a41;
    margin-bottom: 24px;
  }
  .template_pdf_label_structural_features {
    font-family: "Lato";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    color: #323a41;
  }
  .template_pdf_image_location {
    width: 1328px;
    height: 382px;
  }
  .template_pdf_location_score {
    width: 1328px;
    height: 124px;
    background-color: #e6e6e6;
    padding: 16px;
    border-radius: 8px;
  }
  .template_pdf_footer {
    padding-right: 116px;
    padding-left: 116px;
    padding-top: 40px;
    margin-top: 90px;
  }
  .template_pdf_footer_contact_email,
  .template_pdf_footer_contact_number,
  .template_pdf_footer_contact_address {
    color: #ffffff;
    font-family: "Nunito Sans";
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    margin-right: 60px;
    text-align: left;
  }
  .template_pdf_footer_contact_title {
    color: #ffffff;
    font-family: "Nunito Sans";
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    margin-right: 60px;
  }
  .template_logo_footer {
    margin-right: 50px;
  }
  .footer_temp_container {
    width: 1440px;
    height: 90px;
    background: #323a41;
    margin-left: -55px;
    padding-top: 16px;
  }
  .footer_temp_sub_container {
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    padding-right: 16px;
    padding-left: 16px;
    align-items: center;
  }
  .footer_temp_item_container {
    display: grid;
    grid-template-columns: auto auto;
  }
  .grid-container_duo {
    display: grid;
    grid-template-columns: auto auto;
    grid-gap: 10px;
    margin-top: 20px;
  }
  .feature_grid {
    display: grid;
    grid-template-columns: auto;
  }
  .amenities_grid {
    display: grid;
    grid-template-columns: auto;
  }
  .amenities_grid_items {
    display: grid;
    grid-template-columns: auto auto;
    padding-bottom: 20px;
  }
  .amenities_grid_2 {
    display: grid;
    grid-template-columns: auto auto;
  }
  .amenities_grid_padding {
    padding-right: 26px;
    display: grid;
    grid-template-columns: auto;
    align-items: center;
  }
  .amenities_item_container {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: left;
    padding-bottom: 26px;
    align-items: center;
  }
  .ameneties_title_item_container {
    display: grid;
    grid-template-columns: auto auto;
  }
  .property-info_features {
    ul {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr;

      li {
        display: flex;
        align-items: center;
        margin-bottom: 16px;
        svg,
        img {
          margin-right: 16px;
          filter: brightness(0) contrast(0.3);
        }
      }
    }
  }
  .property-details__description {
    white-space: pre-wrap;
  }
  .property-info_structure {
    ul {
      display: flex;
      align-items: center;
      li {
        display: flex;
        align-items: center;
        font-family: "Lato";
        font-size: 32px;
        line-height: 70px;
        font-weight: 700;
        color: var(--primary-grey-400);
        margin-right: 85px;
        svg {
          margin-right: 15px;
          max-width: 38px;
        }
      }
    }
  }
  .image_container {
    width: 652px;
    height: 474px;
    object-fit: stretch;
    box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1), 0px 2px 4px rgba(0, 0, 0, 0.05),
      0px 1px 5px rgba(0, 0, 0, 0.05);
    border-radius: 16px 16px 16px 16px;
  }
  .template_no_data {
    border-bottom: 1px solid var(--primary-grey-200);
  }
  .background-color: var(--background-grey-100);
  border-radius: 8px;
  border: 1px solid var(--background-grey-200);
  padding: 16px;
  position: relative;
  margin-bottom: 16px;

  h3 {
    color: var(--color-secondary-500);
    margin-bottom: 16px;
  }

  h4 {
    font-size: 16px;
    font-weight: bold;
    color: var(--color-black-500);
  }
  p {
    color: var(--color-black-300);
    font-size: 16px;
    font-weight: normal;
    margin: 0;
  }
  .stars-container {
    position: absolute;
    right: 16px;
    top: 16px;

    ul {
      margin: 0;
      list-style: none;
      display: flex;
      gap: 4px;
    }
  }
  .location_score {
    width: 430px;
    background-color: var(--background-grey-100);
    border-radius: 8px;
    border: 1px solid var(--background-grey-200);
    padding: 16px;
    position: relative;
    margin-bottom: 16px;

    h3 {
      color: var(--color-secondary-500);
      margin-bottom: 16px;
    }

    h4 {
      font-size: 16px;
      font-weight: bold;
      color: var(--color-black-500);
    }
    p {
      color: var(--color-black-300);
      font-size: 16px;
      font-weight: normal;
      margin: 0;
    }
    .stars-container {
      position: absolute;
      right: 16px;
      top: 16px;

      ul {
        margin: 0;
        list-style: none;
        display: flex;
        gap: 4px;
      }
    }
  }
  .template_location_score_title {
    padding: 40px 0 20px 0;
  }
  .template_pdf_grid_layout {
    display: grid;
    grid-template-columns: auto auto auto;
    justify-content: space-between;
  }
  .temp_desc_sale_grid_layout {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: left;
    align-items: center;
  }
  .leaflet-container {
    margin-top: 30px;
  }
`;

function TemplatePDF(props) {
  const {
    listing,
    title,
    type,
    address_line_1,
    address_line_2,
    media,
    collections,
    description,
    location_score,
    bedroom_count,
    parking_space_count,
    lot_area,
    floor_area,
    features,
    latitude,
    longitude,
    location,
  } = props; //Change to props depends on the data selected

  const transformedStructuralData = features
    ? features.filter((i) => {
        if (i.type === "structural") {
          return i;
        }
        return null;
      })
    : [];

  const transformedAmenitiesData = features
    ? features.filter((i) => {
        if (i.type === "amenities") {
          return i;
        }
        return null;
      })
    : [];

  // const transformedStructuralData = features.filter((i) => {
  //   if (i.type === "structural") {
  //     return i;
  //   }
  //   return null;
  // });

  // const transformedAmenitiesData = filter((i) => {
  //   if (i.type === "amenities") {
  //     return i;
  //   }
  //   return null;
  // });

  const Amenities = (item, index) => (
    <div key={index} className="amenities_grid_2">
      <div className="amenities_item_container">
        <div className="amenities_grid_padding">
          <img
            src={"/Assets/icons/categories/" + item.slug + ".svg"}
            alt={item.name}
          />
        </div>
        <div className="template_pdf_label_structural_features">
          {item.name}
        </div>
      </div>
    </div>
  );

  const Structural = (item, index) => (
    <div key={index} className="amenities_grid_2">
      <div className="amenities_item_container">
        <div className="amenities_grid_padding">
          <img
            src={"/Assets/icons/categories/" + item.slug + ".svg"}
            alt={item.name}
          />
        </div>
        <div className="template_pdf_label_structural_features">
          {item.name}
        </div>
      </div>
    </div>
  );

  const Images = (media, index) => (
    <div key={index}>
      <img className="image_container" alt={media.file} src={media.file} />
    </div>
  );

  const HeaderPDF = () => (
    <div className="footer_temp_container">
      <div className="footer_temp_sub_container">
        <svg
          className="template_logo_footer"
          width="233"
          height="48"
          viewBox="0 0 233 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 32V0H4.25214H9.54563C13.7978 0 16.271 1.72507 17.5726 3.14825C19.3082 5.04582 20.176 7.5903 20.176 10.566C20.176 13.5418 19.3082 16.1294 17.5726 17.9838C16.271 19.4501 13.7978 21.1752 9.54563 21.1752H5.03315V32H0ZM9.54563 16.6469C11.6283 16.6469 13.1903 16.0863 14.2317 14.965C15.4032 13.6712 15.6635 11.8598 15.6635 10.566C15.6635 9.31536 15.4032 7.50404 14.2317 6.21024C13.1903 5.08895 11.6283 4.48518 9.54563 4.48518H5.03315V16.6469H9.54563ZM41.8943 17.9838C41.1133 18.8464 39.8984 19.8383 38.1628 20.442L46.8407 32H41.1567L33.0429 21.1752H29.3548V32H24.3217V0H28.5738H33.8673C38.1195 0 40.5926 1.72507 41.8943 3.19137C43.5865 5.04582 44.4977 7.63342 44.4977 10.6092C44.4977 13.5418 43.5865 16.1294 41.8943 17.9838ZM29.3548 4.5283V16.69H33.8673C35.95 16.69 37.512 16.0863 38.51 14.965C39.7248 13.6712 39.9418 11.8598 39.9418 10.6092C39.9418 9.31536 39.7248 7.50404 38.51 6.21024C37.512 5.08895 35.95 4.5283 33.8673 4.5283H29.3548ZM67.2476 26.3886C71.7122 25.5297 75.1536 21.1776 75.1536 16C75.1536 10.1171 71.0976 5.34848 65.2033 5.34848C63.9988 5.34848 62.8409 5.54762 61.7608 5.91472C63.1367 5.45646 64.6587 5.26844 66.2814 5.42509C66.6937 5.46489 67.1125 5.52693 67.537 5.61244C67.1287 5.691 66.7289 5.79876 66.3394 5.93369C62.4707 7.27415 59.6255 11.296 59.6255 16C59.6255 21.0732 62.6419 25.3178 67.2523 26.3901L67.2476 26.3886ZM56.6989 9.56375C55.4464 11.2097 54.6627 13.2305 54.5462 15.4279C54.6616 13.2819 55.4324 11.24 56.6989 9.56375ZM54.5311 16C54.5309 15.8086 54.536 15.6178 54.5462 15.4279C54.5362 15.6173 54.5311 15.8081 54.5311 16ZM69.1889 32C67.8289 32 66.5409 31.8006 65.3348 31.4356C66.6876 31.8152 68.0635 32 69.3948 32C78.2482 32 85.4259 24.8362 85.4259 16C85.4259 7.16376 78.2482 0 69.3948 0H69.301H65.5903C66.868 0 68.0822 0.176042 69.2246 0.5C70.0076 0.722035 70.7569 1.01355 71.4698 1.3655C69.494 0.454216 67.3884 0 65.3843 0C56.5309 0 49.3532 7.16376 49.3532 16C49.3532 24.8362 56.5309 32 65.3843 32H69.1889ZM80.248 16C80.212 17.3128 79.9969 18.4925 79.6425 19.5457C80.0347 18.4365 80.248 17.2431 80.248 16ZM75.3044 24.9887C74.1109 25.7276 72.8151 26.2135 71.5537 26.469C72.9122 26.2149 74.1799 25.704 75.3044 24.9887ZM55.0311 15.9996V16C55.0311 21.4285 56.9844 25.2909 59.7339 27.7998C62.4937 30.3181 66.0858 31.5 69.3948 31.5C77.973 31.5 84.9259 24.5592 84.9259 16C84.9259 7.96672 78.8012 1.35904 70.9564 0.577376C77.0439 3.15045 80.748 9.89478 80.748 16C80.748 22.16 75.7454 27.1515 69.5758 27.1515C63.3612 27.1515 59.1255 22.1127 59.1255 16C59.1255 11.5125 61.6154 7.58431 65.1797 5.87139C59.2801 5.86501 55.0265 10.6727 55.0311 15.9996ZM90.8099 32H95.8321V21.1752H100.335C104.578 21.1752 107.045 19.4501 108.344 17.9838C110.076 16.1294 110.942 13.5418 110.942 10.566C110.942 7.5903 110.076 5.04582 108.344 3.14825C107.045 1.72507 104.578 0 100.335 0H95.0528H90.8099V32ZM105.01 14.965C103.971 16.0863 102.413 16.6469 100.335 16.6469H95.8321V4.48518H100.335C102.413 4.48518 103.971 5.08895 105.01 6.21024C106.179 7.50404 106.439 9.31536 106.439 10.566C106.439 11.8598 106.179 13.6712 105.01 14.965ZM120.101 4.48518H134.344V0H120.057H115.078V32H120.057H134.344V27.4717H120.101V17.5526H131.833V13.0243H120.101V4.48518ZM145.299 27.4717H158.721V32H145.256H140.277V0H145.299V27.4717ZM180.833 27.4717H167.412V0H162.389V32H167.368H180.833V27.4717ZM203.768 4.48518H189.524V13.0243H201.257V17.5526H189.524V27.4717H203.768V32H189.481H184.502V0H189.481H203.768V4.48518ZM223.511 20.442C225.243 19.8383 226.455 18.8464 227.235 17.9838C228.923 16.1294 229.832 13.5418 229.832 10.6092C229.832 7.63342 228.923 5.04582 227.235 3.19137C225.936 1.72507 223.468 0 219.225 0H213.943H209.7V32H214.723V21.1752H218.403L226.499 32H232.17L223.511 20.442ZM214.723 16.69V4.5283H219.225C221.303 4.5283 222.862 5.08895 223.858 6.21024C225.07 7.50404 225.286 9.31536 225.286 10.6092C225.286 11.8598 225.07 13.6712 223.858 14.965C222.862 16.0863 221.303 16.69 219.225 16.69H214.723ZM133.141 45.92C132.821 45.768 132.557 45.536 132.349 45.224L131.401 46.04C131.689 46.44 132.077 46.736 132.565 46.928C133.053 47.12 133.569 47.216 134.113 47.216C134.521 47.216 134.905 47.156 135.265 47.036C135.625 46.916 135.937 46.744 136.201 46.52C136.465 46.296 136.673 46.02 136.825 45.692C136.985 45.364 137.065 44.996 137.065 44.588C137.065 44.076 136.961 43.676 136.753 43.388C136.545 43.092 136.285 42.86 135.973 42.692C135.669 42.516 135.333 42.38 134.965 42.284C134.605 42.188 134.269 42.08 133.957 41.96C133.653 41.84 133.397 41.684 133.189 41.492C132.981 41.3 132.877 41.024 132.877 40.664C132.877 40.536 132.901 40.396 132.949 40.244C133.005 40.092 133.097 39.952 133.225 39.824C133.353 39.688 133.521 39.58 133.729 39.5C133.945 39.412 134.213 39.368 134.533 39.368C134.869 39.368 135.169 39.436 135.433 39.572C135.697 39.708 135.901 39.888 136.045 40.112L136.981 39.26C136.661 38.868 136.289 38.608 135.865 38.48C135.441 38.352 134.997 38.288 134.533 38.288C134.021 38.288 133.581 38.368 133.213 38.528C132.853 38.68 132.557 38.872 132.325 39.104C132.093 39.336 131.921 39.592 131.809 39.872C131.705 40.152 131.653 40.416 131.653 40.664C131.653 41.216 131.757 41.656 131.965 41.984C132.173 42.304 132.429 42.56 132.733 42.752C133.045 42.944 133.381 43.096 133.741 43.208C134.109 43.312 134.445 43.424 134.749 43.544C135.061 43.656 135.321 43.8 135.529 43.976C135.737 44.144 135.841 44.392 135.841 44.72C135.841 44.952 135.789 45.156 135.685 45.332C135.581 45.508 135.445 45.656 135.277 45.776C135.117 45.896 134.937 45.988 134.737 46.052C134.537 46.108 134.341 46.136 134.149 46.136C133.805 46.136 133.469 46.064 133.141 45.92ZM32.092 38.504H35.08C35.624 38.504 36.072 38.58 36.424 38.732C36.776 38.876 37.052 39.064 37.252 39.296C37.46 39.52 37.604 39.776 37.684 40.064C37.764 40.344 37.804 40.616 37.804 40.88C37.804 41.152 37.756 41.416 37.66 41.672C37.564 41.92 37.424 42.148 37.24 42.356C37.064 42.556 36.844 42.728 36.58 42.872C36.324 43.008 36.036 43.092 35.716 43.124L38.128 47H36.688L34.528 43.256H33.244V47H32.092V38.504ZM33.244 42.248H34.756C34.98 42.248 35.2 42.232 35.416 42.2C35.64 42.16 35.836 42.092 36.004 41.996C36.18 41.9 36.32 41.764 36.424 41.588C36.528 41.404 36.58 41.168 36.58 40.88C36.58 40.592 36.528 40.36 36.424 40.184C36.32 40 36.18 39.86 36.004 39.764C35.836 39.668 35.64 39.604 35.416 39.572C35.2 39.532 34.98 39.512 34.756 39.512H33.244V42.248ZM41.8279 38.504H47.3119V39.584H42.9799V42.116H47.0119V43.196H42.9799V45.92H47.5279V47H41.8279V38.504ZM55.2719 38.504H54.2279L50.4839 47H51.8279L52.6679 44.9H56.7119L57.5639 47H58.9079L55.2719 38.504ZM54.7079 39.992L56.2919 43.892H53.0759L54.6839 39.992H54.7079ZM62.4131 38.504H63.5651V45.92H67.4651V47H62.4131V38.504ZM68.9742 39.584H71.7102V47H72.8622V39.584H75.5982V38.504H68.9742V39.584ZM81.2288 43.376L78.0128 38.504H79.4888L81.8048 42.236L84.1928 38.504H85.5968L82.3808 43.376V47H81.2288V43.376ZM95.8643 38.504H94.7123V47H95.8643V38.504ZM100.452 38.504H101.964L106.644 45.488H106.668V38.504H107.82V47H106.356L101.628 40.016H101.604V47H100.452V38.504ZM112.571 38.504H111.239L114.515 47H115.595L118.943 38.504H117.683L115.091 45.416H115.067L112.571 38.504ZM122.362 38.504H127.846V39.584H123.514V42.116H127.546V43.196H123.514V45.92H128.062V47H122.362V38.504ZM142.941 39.584H140.205V38.504H146.829V39.584H144.093V47H142.941V39.584ZM152.088 38.504H150.372V47H151.524V40.016H151.548L154.416 47H155.184L158.052 40.016H158.076V47H159.228V38.504H157.512L154.836 44.936H154.788L152.088 38.504ZM163.731 38.504H169.215V39.584H164.883V42.116H168.915V43.196H164.883V45.92H169.431V47H163.731V38.504ZM174.979 38.504H173.467V47H174.619V40.016H174.643L179.371 47H180.835V38.504H179.683V45.488H179.659L174.979 38.504ZM187.194 39.584H184.458V38.504H191.082V39.584H188.346V47H187.194V39.584ZM195.752 45.92C195.432 45.768 195.168 45.536 194.96 45.224L194.012 46.04C194.3 46.44 194.688 46.736 195.176 46.928C195.664 47.12 196.18 47.216 196.724 47.216C197.132 47.216 197.516 47.156 197.876 47.036C198.236 46.916 198.548 46.744 198.812 46.52C199.076 46.296 199.284 46.02 199.436 45.692C199.596 45.364 199.676 44.996 199.676 44.588C199.676 44.076 199.572 43.676 199.364 43.388C199.156 43.092 198.896 42.86 198.584 42.692C198.28 42.516 197.944 42.38 197.576 42.284C197.216 42.188 196.88 42.08 196.568 41.96C196.264 41.84 196.008 41.684 195.8 41.492C195.592 41.3 195.488 41.024 195.488 40.664C195.488 40.536 195.512 40.396 195.56 40.244C195.616 40.092 195.708 39.952 195.836 39.824C195.964 39.688 196.132 39.58 196.34 39.5C196.556 39.412 196.824 39.368 197.144 39.368C197.48 39.368 197.78 39.436 198.044 39.572C198.308 39.708 198.512 39.888 198.656 40.112L199.592 39.26C199.272 38.868 198.9 38.608 198.476 38.48C198.052 38.352 197.608 38.288 197.144 38.288C196.632 38.288 196.192 38.368 195.824 38.528C195.464 38.68 195.168 38.872 194.936 39.104C194.704 39.336 194.532 39.592 194.42 39.872C194.316 40.152 194.264 40.416 194.264 40.664C194.264 41.216 194.368 41.656 194.576 41.984C194.784 42.304 195.04 42.56 195.344 42.752C195.656 42.944 195.992 43.096 196.352 43.208C196.72 43.312 197.056 43.424 197.36 43.544C197.672 43.656 197.932 43.8 198.14 43.976C198.348 44.144 198.452 44.392 198.452 44.72C198.452 44.952 198.4 45.156 198.296 45.332C198.192 45.508 198.056 45.656 197.888 45.776C197.728 45.896 197.548 45.988 197.348 46.052C197.148 46.108 196.952 46.136 196.76 46.136C196.416 46.136 196.08 46.064 195.752 45.92Z"
            fill="white"
          />
        </svg>
        <div className="template_pdf_footer_contact_title">Get in touch</div>

        <div className="footer_temp_item_container">
          <svg
            width="20"
            height="17"
            viewBox="0 0 20 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.4225 5.23005L10 9.21127L3.57746 5.23005V3.61502L10 7.6338L16.4225 3.61502V5.23005ZM16.4225 2H3.57746C3.12676 2 2.75117 2.18779 2.4507 2.48826C2.15023 2.82629 2 3.20188 2 3.61502V13.23C2 13.6808 2.15023 14.0563 2.4507 14.3568C2.75117 14.6948 3.12676 14.8451 3.57746 14.8451H16.4225C16.8357 14.8451 17.2113 14.6948 17.5117 14.3568C17.8122 14.0563 18 13.6808 18 13.23V3.61502C18 3.20188 17.8122 2.82629 17.5117 2.48826C17.2113 2.18779 16.8357 2 16.4225 2Z"
              fill="#FFFFFF"
            />
          </svg>

          <div className="template_pdf_footer_contact_email">
            propeller.realty@gmail.com
          </div>
        </div>

        <div className="footer_temp_item_container">
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.20833 8.91667L7.16667 6.95833C7.41667 6.70833 7.45833 6.41667 7.375 6.04167C7.04167 5.04167 6.875 4 6.875 2.875C6.875 2.625 6.79167 2.41667 6.625 2.25C6.45833 2.08333 6.25 2 6 2H2.875C2.625 2 2.41667 2.08333 2.25 2.25C2.08333 2.41667 2 2.625 2 2.875C2 7.04167 3.45833 10.625 6.41667 13.5833C9.375 16.5417 12.9583 18 17.125 18C17.375 18 17.5833 17.9167 17.75 17.75C17.9167 17.5833 18 17.375 18 17.125V14C18 13.75 17.9167 13.5417 17.75 13.375C17.5833 13.2083 17.375 13.125 17.125 13.125C16 13.125 14.9583 12.9583 13.9583 12.625C13.625 12.5 13.2917 12.5833 13.0417 12.8333L11.0833 14.7917C8.5 13.4583 6.54167 11.5 5.20833 8.91667Z"
              fill="#FFFFFF"
            />
          </svg>
          <div className="template_pdf_footer_contact_number">
            +63906-0012922
          </div>
        </div>
        <div className="footer_temp_item_container">
          <svg
            width="16"
            height="20"
            viewBox="0 0 16 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.59624 9.58685C7.03286 9.58685 6.5446 9.39906 6.16901 9.02347C5.79343 8.64789 5.60563 8.15962 5.60563 7.59624C5.60563 7.07042 5.79343 6.58216 6.16901 6.20657C6.5446 5.83099 7.03286 5.60563 7.59624 5.60563C8.12207 5.60563 8.61033 5.83099 8.98592 6.20657C9.3615 6.58216 9.58685 7.07042 9.58685 7.59624C9.58685 8.15962 9.3615 8.64789 8.98592 9.02347C8.61033 9.39906 8.12207 9.58685 7.59624 9.58685ZM7.59624 2C6.01878 2 4.70423 2.56338 3.61502 3.65258C2.52582 4.74178 2 6.05634 2 7.59624C2 8.38498 2.18779 9.28639 2.60094 10.3005C2.97653 11.3521 3.42723 12.2535 3.91549 13.0798C4.40376 13.9061 4.96714 14.7324 5.64319 15.5962C6.28169 16.4601 6.73239 17.0235 6.99531 17.3239C7.22066 17.6244 7.44601 17.8498 7.59624 18L8.19718 17.3615C8.57277 16.9108 9.02347 16.3099 9.5493 15.5587C10.0751 14.8075 10.6385 13.9812 11.2019 13.0798C11.7277 12.216 12.216 11.277 12.5915 10.2629C12.9671 9.28639 13.1925 8.38498 13.1925 7.59624C13.1925 6.05634 12.6291 4.74178 11.5399 3.65258C10.4507 2.56338 9.13615 2 7.59624 2Z"
              fill="#FFFFFF"
            />
          </svg>
          <div className="template_pdf_footer_contact_address">
            West Capitol Drive, Kapitolyo, Pasig
          </div>
        </div>
      </div>
    </div>
  );

  const PDFInfo = ({ data }) => {
    const {
      listing,
      type,
      title,
      address_line_1,
      address_line_2,
      bedroom_count,
      parking_space_count,
      lot_area,
      floor_area,
    } = data;
    return (
      <div>
        <div className="template_pdf_desc_container">
          <div className="temp_desc_sale_grid_layout">
            <div className="template_description_sale">
              {listing.transaction_type}
            </div>
            <div className="template_description_type_house">{type}</div>
          </div>
          <div className="small_label_location_name">{title}</div>
          <div className="small_label_price">
            <ListingPrice
              transaction_type={listing.transaction_type}
              sale_price={listing.sale_price}
              lease_price={listing.monthly_lease_price}
            />
          </div>
        </div>
        <div className="temp_desc_sale_grid_layout">
          <div className="template_pdf_location_icon">
            <svg
              width="15"
              height="18"
              viewBox="0 0 12 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.59624 7.58685C5.03286 7.58685 4.5446 7.39906 4.16901 7.02347C3.79343 6.64789 3.60563 6.15962 3.60563 5.59624C3.60563 5.07042 3.79343 4.58216 4.16901 4.20657C4.5446 3.83099 5.03286 3.60563 5.59624 3.60563C6.12207 3.60563 6.61033 3.83099 6.98592 4.20657C7.3615 4.58216 7.58685 5.07042 7.58685 5.59624C7.58685 6.15962 7.3615 6.64789 6.98592 7.02347C6.61033 7.39906 6.12207 7.58685 5.59624 7.58685ZM5.59624 0C4.01878 0 2.70423 0.56338 1.61502 1.65258C0.525822 2.74178 0 4.05634 0 5.59624C0 6.38498 0.187793 7.28639 0.600939 8.30047C0.976526 9.35211 1.42723 10.2535 1.91549 11.0798C2.40376 11.9061 2.96714 12.7324 3.64319 13.5962C4.28169 14.4601 4.73239 15.0235 4.99531 15.3239C5.22066 15.6244 5.44601 15.8498 5.59624 16L6.19718 15.3615C6.57277 14.9108 7.02347 14.3099 7.5493 13.5587C8.07512 12.8075 8.6385 11.9812 9.20188 11.0798C9.7277 10.216 10.216 9.277 10.5915 8.26291C10.9671 7.28639 11.1925 6.38498 11.1925 5.59624C11.1925 4.05634 10.6291 2.74178 9.53991 1.65258C8.4507 0.56338 7.13615 0 5.59624 0Z"
                fill="#7E6947"
              />
            </svg>
          </div>
          <div>
            <p className="template_pdf_location_address">
              {address_line_1} {address_line_2}
            </p>
          </div>
        </div>
        <div className="property-info_structure">
          <ul>
            {bedroom_count ? (
              <li className="no-bedroom">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M42.9496 23.2109V22.411C42.9496 20.9375 42.1867 19.6395 41.0358 18.8889V10.1634C41.0358 7.86769 39.1682 6 36.8724 6H11.1276C8.83185 6 6.96408 7.86769 6.96408 10.1634V18.8888C5.81318 19.6394 5.05029 20.9374 5.05029 22.4109V23.2108C3.87183 23.5211 3 24.5957 3 25.8703V35.2298C3 36.7022 4.16337 37.9079 5.61918 37.9764V39.084C5.61918 39.7623 6.16903 40.3121 6.84727 40.3121C7.5255 40.3121 8.07536 39.7623 8.07536 39.084V37.9796H39.9246V39.084C39.9246 39.7623 40.4744 40.3121 41.1527 40.3121C41.8309 40.3121 42.3807 39.7623 42.3807 39.084V37.9764C43.8366 37.9078 45 36.7022 45 35.2297V25.8703C45 24.5957 44.1282 23.5211 42.9496 23.2109ZM9.42034 10.1634C9.42034 9.22202 10.1862 8.45618 11.1276 8.45618H36.8724C37.8138 8.45618 38.5797 9.22202 38.5797 10.1634V18.208H36.9422V16.0433C36.9422 14.5282 35.7095 13.2955 34.1944 13.2955H27.5861C26.071 13.2955 24.8383 14.5282 24.8383 16.0433V18.208H23.1617V16.0433C23.1617 14.5282 21.929 13.2955 20.4139 13.2955H13.8056C12.2904 13.2955 11.0578 14.5282 11.0578 16.0433V18.208H9.42034V10.1634ZM34.4859 16.0433V17.9164C34.4859 18.0771 34.355 18.2079 34.1944 18.2079H27.5861C27.4253 18.2079 27.2945 18.0771 27.2945 17.9164V16.0433C27.2945 15.8825 27.4254 15.7517 27.5861 15.7517H34.1944C34.3551 15.7517 34.4859 15.8825 34.4859 16.0433ZM20.7055 16.0433V17.9164C20.7055 18.0771 20.5746 18.2079 20.4139 18.2079H13.8056C13.6449 18.2079 13.5141 18.0771 13.5141 17.9164V16.0433C13.5141 15.8825 13.6449 15.7517 13.8056 15.7517H20.4139C20.5746 15.7517 20.7055 15.8825 20.7055 16.0433ZM7.50655 22.4109C7.50655 21.4477 8.2902 20.6642 9.25341 20.6642H38.7466C39.7098 20.6642 40.4934 21.4478 40.4934 22.4109V23.1203H7.50655V22.4109ZM42.5437 35.2297C42.5437 35.3916 42.412 35.5234 42.25 35.5234H5.74993C5.588 35.5234 5.45618 35.3916 5.45618 35.2297V25.8703C5.45618 25.7084 5.58792 25.5767 5.74993 25.5767H42.2501C42.412 25.5767 42.5438 25.7084 42.5438 25.8703V35.2297H42.5437Z"
                    fill="#323A41"
                  />
                </svg>
                {bedroom_count || "-"}
              </li>
            ) : null}

            {bedroom_count ? (
              <li className="no-garage">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M44.7256 16.5076L24.5067 6.14021C24.1864 5.96368 23.8051 5.96368 23.4855 6.14021L3.26655 16.7058C3.01258 16.8469 2.92136 17.1665 3.06246 17.4198L3.57302 18.3379C3.71411 18.5912 4.0337 18.6824 4.28701 18.5413L23.9961 8.25858L43.7052 18.3438C43.9585 18.4842 44.2781 18.3937 44.4185 18.1404L44.9297 17.2223C45.0708 16.9683 44.9796 16.6487 44.7256 16.5076V16.5076ZM35.3741 23.1843L34.3799 20.1327C33.6757 17.9717 31.6611 16.5089 29.3878 16.5089H18.6037C16.3305 16.5089 14.3158 17.9717 13.6116 20.1327L12.6174 23.1843C10.6749 23.954 9.29615 25.8408 9.29615 28.0576V36.4575C9.29615 38.1946 10.7091 39.6075 12.4461 39.6075H13.4961C15.2332 39.6075 16.6461 38.1946 16.6461 36.4575V35.4075H31.3461V36.4575C31.3461 38.1946 32.759 39.6075 34.4961 39.6075H35.546C37.2831 39.6075 38.696 38.1946 38.696 36.4575V28.0576C38.696 25.8408 37.3173 23.954 35.3741 23.1843ZM15.6086 20.7831C15.8136 20.1504 16.2139 19.599 16.7522 19.2083C17.2904 18.8176 17.9386 18.6078 18.6037 18.6089H29.3885C30.7561 18.6089 31.9597 19.483 32.3836 20.7831L33.0431 22.8076H14.9491L15.6086 20.7831ZM14.5461 36.4575C14.5461 37.037 14.0743 37.5075 13.4961 37.5075H12.4461C11.868 37.5075 11.3961 37.037 11.3961 36.4575V35.4075H14.5461V36.4575ZM36.596 36.4575C36.596 37.037 36.1242 37.5075 35.546 37.5075H34.4961C33.9179 37.5075 33.4461 37.037 33.4461 36.4575V35.4075H36.596V36.4575ZM36.596 31.2075V33.3075H11.3961V28.0576C11.3961 26.3205 12.809 24.9076 14.5461 24.9076H33.4461C35.1831 24.9076 36.596 26.3205 36.596 28.0576V31.2075ZM31.8186 26.4832C30.237 26.4832 28.1961 28.0083 28.1961 29.6286C28.1961 30.4148 28.58 31.7332 31.1531 31.7332L31.8186 31.7266C33.5222 31.7266 34.7586 30.6241 34.7586 29.1049C34.7586 27.5857 33.5222 26.4832 31.8186 26.4832ZM31.8186 30.1516C31.6138 30.1516 31.3835 30.1582 31.1531 30.1582C30.4621 30.1582 29.7711 30.0991 29.7711 29.6286C29.7711 29.0006 30.9996 28.0582 31.8186 28.0582C32.6376 28.0582 33.1836 28.4769 33.1836 29.1049C33.1836 29.733 32.6369 30.1516 31.8186 30.1516ZM16.1736 26.4832C14.47 26.4832 13.2336 27.5857 13.2336 29.1049C13.2336 30.6241 14.47 31.7266 16.1736 31.7266L16.8391 31.7332C19.4122 31.7332 19.7961 30.4141 19.7961 29.6286C19.7961 28.0083 17.7552 26.4832 16.1736 26.4832V26.4832ZM16.8391 30.1582C16.6087 30.1582 16.3784 30.1516 16.1736 30.1516C15.3546 30.1516 14.8086 29.733 14.8086 29.1049C14.8086 28.4769 15.3546 28.0582 16.1736 28.0582C16.9926 28.0582 18.2211 29.0006 18.2211 29.6286C18.2211 30.0991 17.5301 30.1582 16.8391 30.1582Z"
                    fill="#323A41"
                  />
                </svg>
                {parking_space_count || "-"}
              </li>
            ) : null}
            {lot_area && (
              <li className="lot-area">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.89153 22.0348C8.06864 22.06 8.24542 22.0725 8.42121 22.0725C8.84047 22.0725 9.25268 22.0006 9.64372 21.8619V35.4024C9.64372 36.0819 10.1946 36.6328 10.8742 36.6328H37.1242C37.8037 36.6328 38.3547 36.0819 38.3547 35.4024V21.8618C38.7455 22.0001 39.1588 22.0719 39.5832 22.0719C40.7403 22.0719 41.845 21.5199 42.5381 20.5954C43.1298 19.8066 43.3788 18.8347 43.2394 17.8584C43.1 16.8822 42.5886 16.0187 41.7998 15.4272L38.3547 12.8432V4.23047C38.3547 3.55092 37.8037 3 37.1242 3H32.2023C31.5228 3 30.9718 3.55092 30.9718 4.23047V7.30598L26.2133 3.73713C24.9096 2.76063 23.0886 2.76063 21.7845 3.73754L6.19865 15.427C5.40976 16.0186 4.89838 16.8821 4.75901 17.8583C4.61955 18.8346 4.8686 19.8066 5.46004 20.595C6.05157 21.384 6.91511 21.8954 7.89153 22.0348ZM12.1047 34.1719V20.2264L23.9992 11.3053L35.8937 20.2264V34.1719H12.1047ZM33.4328 5.46094H35.8937V10.9975L33.4328 9.15177V5.46094ZM7.19525 18.2063C7.24168 17.8808 7.41222 17.593 7.67522 17.3957L23.2605 5.70679C23.478 5.54379 23.7387 5.46241 23.9994 5.46241C24.2599 5.46241 24.5203 5.54379 24.7373 5.70638L40.3233 17.3958C40.5862 17.593 40.7567 17.8809 40.8032 18.2063C40.8496 18.5317 40.7667 18.8557 40.5693 19.1188C40.3348 19.4316 39.9754 19.611 39.5832 19.611C39.3162 19.611 39.0615 19.5259 38.847 19.3652L24.7375 8.78279C24.2999 8.45467 23.6985 8.45467 23.2609 8.78279L9.15153 19.3651C8.88871 19.5621 8.56444 19.6448 8.23935 19.5986C7.91393 19.5522 7.62616 19.3817 7.42888 19.1185C7.23176 18.8557 7.14874 18.5317 7.19525 18.2063Z"
                    fill="#323A41"
                  />
                  <path
                    d="M44.6396 39.6183L41.3584 36.3371C40.8779 35.8565 40.0988 35.8565 39.6182 36.3371C39.1377 36.8176 39.1377 37.5966 39.6182 38.0772L40.7989 39.2579H7.20103L8.38178 38.0771C8.86232 37.5966 8.86232 36.8175 8.38178 36.337C7.90133 35.8564 7.12219 35.8564 6.64166 36.337L3.3604 39.6182C2.87987 40.0988 2.87987 40.8778 3.3604 41.3584L6.64166 44.6396C6.88192 44.88 7.19676 45.0001 7.51168 45.0001C7.8266 45.0001 8.14151 44.88 8.3817 44.6396C8.86224 44.1591 8.86224 43.38 8.3817 42.8995L7.20103 41.7188H40.7989L39.6181 42.8996C39.1376 43.3801 39.1376 44.1592 39.6181 44.6397C39.8585 44.88 40.1733 45.0001 40.4883 45.0001C40.8032 45.0001 41.1181 44.88 41.3583 44.6396L44.6395 41.3584C45.1201 40.8779 45.1201 40.0988 44.6396 39.6183Z"
                    fill="#323A41"
                  />
                  <path
                    d="M31.3828 20.2266H16.6172C15.9376 20.2266 15.3867 20.7775 15.3867 21.457V28.8398C15.3867 29.5194 15.9376 30.0703 16.6172 30.0703H31.3828C32.0624 30.0703 32.6133 29.5194 32.6133 28.8398V21.457C32.6133 20.7775 32.0624 20.2266 31.3828 20.2266ZM17.8477 22.6875H22.7695V27.6094H17.8477V22.6875ZM30.1523 27.6094H25.2305V22.6875H30.1523V27.6094Z"
                    fill="#323A41"
                  />
                </svg>
                {lot_area} sqm
              </li>
            )}
            {floor_area && (
              <li className="floor-area">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M5.92546 14.231C5.92546 15.0388 5.27074 15.6938 4.46273 15.6938C3.65472 15.6938 3 15.0388 3 14.2312V4.46273C3 3.65491 3.65472 3 4.46273 3H14.2316C15.0396 3 15.6943 3.65491 15.6943 4.46273C15.6943 5.27054 15.0394 5.92546 14.2316 5.92546H7.99356L17.4149 15.3446C17.9863 15.9157 17.9863 16.8419 17.4151 17.4131C17.1296 17.6989 16.7551 17.8416 16.3806 17.8416C16.0064 17.8416 15.6321 17.6989 15.3464 17.4133L5.92546 7.99434V14.231ZM42.0743 33.7677C42.0743 32.9599 42.729 32.305 43.537 32.305C44.3448 32.305 44.9997 32.9599 44.9999 33.7677V43.5357C44.9999 44.3435 44.3452 44.9984 43.5372 44.9984H33.7689C32.9609 44.9984 32.3062 44.3435 32.3062 43.5357C32.3062 42.7278 32.9609 42.0729 33.7689 42.0729H40.0054L30.2946 32.3622C29.7234 31.7911 29.7234 30.8649 30.2946 30.2937C30.8659 29.7224 31.7919 29.7224 32.3633 30.2937L42.0743 40.0046V33.7677ZM15.6364 30.2937L5.92642 40.0045V33.7678C5.92642 32.96 5.2717 32.305 4.46369 32.305C3.65568 32.305 3.00096 32.96 3.00096 33.7678V43.5361C3.00096 44.3439 3.65568 44.9988 4.46369 44.9988H14.2316C15.0394 44.9988 15.6943 44.3439 15.6943 43.5361C15.6943 42.7282 15.0396 42.0733 14.2316 42.0733H7.99491L17.7051 32.3622C18.2763 31.7909 18.2763 30.8647 17.7049 30.2935C17.134 29.7224 16.2078 29.7224 15.6364 30.2937ZM33.7689 3H43.5372C44.345 3 44.9999 3.65472 45.0001 4.46273V14.231C45.0001 15.0388 44.3454 15.6938 43.5374 15.6938C42.7294 15.6938 42.0747 15.0388 42.0747 14.231V7.99395L32.6551 17.4141C32.3694 17.6996 31.9949 17.8426 31.6206 17.8426C31.2464 17.8426 30.8719 17.6998 30.5864 17.4143C30.015 16.8431 30.015 15.9169 30.5862 15.3456L40.0058 5.92546H33.7689C32.9609 5.92546 32.3062 5.27054 32.3062 4.46273C32.3062 3.65491 32.9609 3 33.7689 3Z"
                    fill="#323A41"
                  />
                </svg>
                {floor_area} sqm
              </li>
            )}
          </ul>
        </div>
      </div>
    );
  };

  const LocationCoordinates = ({ data }) => {
    const { latitude, longitude, location } = data;
    return (
      <PropertyDetailsMap
        PropertyLat={latitude}
        PropertyLong={longitude}
        PropertyLocation={location?.coordinates}
      />
    );
  };

  const PropertyImages = ({ data }) => {
    if (!data || !data.media) {
      return null; // return early if data or media is not defined
    }

    return (
      <div className="template_pdf_images_container">
        <div className="grid-container_duo">
          {data.media.map((item, index) => Images(item, index))}
        </div>
      </div>
    );
  };

  const PropertyDescription = ({ data }) => (
    <div className="template_pdf_label_details_container">
      <div className="template_pdf_label_title_details">Property details</div>
      <div className="property-details__description">
        <p>{data.description}</p>
      </div>
    </div>
  );

  const Features = ({ data }) => {
    const hasStructuralData = data.transformedStructuralData.length > 0;
    const hasAmenitiesData = data.transformedAmenitiesData.length > 0;

    if (!hasStructuralData && !hasAmenitiesData) {
      return null;
    }

    return (
      <>
        <hr className="template_pdf_divider" align={"left"} />
        <div className="template_pdf_description_icon_container">
          <div className="amenities_grid">
            <div className="amenities_grid_items">
              {hasStructuralData && (
                <div>
                  <div className="template_pdf_label_title_details">
                    Structural Features
                  </div>
                  <div className="ameneties_title_item_container">
                    {data.transformedStructuralData.map((val, index) =>
                      Structural(val, index)
                    )}
                  </div>
                </div>
              )}

              {hasAmenitiesData && (
                <div>
                  <div className="template_pdf_label_title_details">
                    Amenities
                  </div>
                  <div className="ameneties_title_item_container">
                    {data.transformedAmenitiesData.map((val, index) =>
                      Amenities(val, index)
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  };

  const LocationScoreFunc = ({ data }) => {
    class Score {
      constructor(stars, title, description) {
        this.stars = stars;
        this.title = title;
        this.description = description;
      }
    }

    const ALL_SCORES = {
      walk: [
        new Score(1, "Car-Dependent", "Almost all errands require a car"),
        new Score(2, "Car-Dependent", "Most errands require a car"),
        new Score(
          3,
          "Somewhat Walkable",
          "Some errands can be accomplished on foot"
        ),
        new Score(
          4,
          "Very Walkable",
          "Most errands can be accomplished on foot"
        ),
        new Score(5, "Walker's Paradise", "Daily errands do not require a car"),
      ],
      bike: [
        new Score(1, "Somewhat Bikeable", "Minimal bike infrastructure"),
        new Score(2, "Bikeable", "Some bike infrastructure"),
        new Score(3, "Very Bikeable", "Biking is convenient for most trips"),
        new Score(
          4,
          "Biker's Paradise",
          "Daily errands can be accomplished on bike"
        ),
        new Score(
          5,
          "Biker's Paradise",
          "Daily errands can be accomplished on bike"
        ),
      ],
      transit: [
        new Score(1, "Minimal Transit", "It is possible to get on a bus"),
        new Score(
          2,
          "Some Transit",
          "A few nearby public transportation options"
        ),
        new Score(
          3,
          "Good Transit",
          "Many nearby public transportation options"
        ),
        new Score(
          4,
          "Excellent Transit",
          "Transit is convenient for most trips"
        ),
        new Score(5, "Rider's Paradise", "World-class public transportation"),
      ],
    };

    const Star = ({ filled }) => {
      if (!filled) {
        return (
          <li>
            <svg
              width="20"
              height="18"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.51689 6.38124L7.25898 6.4178L2.88964 7.03726L2.88928 7.03731C2.50041 7.09215 2.38428 7.5307 2.63388 7.76704L2.63402 7.76718L5.79514 10.7627L5.9904 10.9477L5.9436 11.2126L5.196 15.4437C5.19599 15.4438 5.19598 15.4438 5.19597 15.4439C5.13918 15.7673 5.50476 16.077 5.8621 15.8928L5.86365 15.892L9.77243 13.894L10 13.7777L10.2276 13.894L14.1363 15.892L14.1364 15.892C14.4971 16.0764 14.8602 15.7646 14.8041 15.4441C14.8041 15.4441 14.8041 15.4441 14.8041 15.444C14.804 15.4439 14.804 15.4438 14.804 15.4437L14.0564 11.2126L14.0096 10.9477L14.2049 10.7627L17.366 7.76718L17.3661 7.76704C17.6157 7.5307 17.4996 7.09215 17.1107 7.03731L17.1104 7.03726L12.741 6.4178L12.4831 6.38124L12.3653 6.14891L10.4129 2.29933C10.4128 2.29922 10.4127 2.2991 10.4127 2.29899C10.2456 1.97198 9.75279 1.97343 9.58761 2.2984L7.51689 6.38124ZM7.51689 6.38124L7.63472 6.14891L9.58751 2.29859L7.51689 6.38124Z"
                fill="#7E6947"
                stroke="#7E6947"
              />
            </svg>
          </li>
        );
      } else {
        return (
          <li>
            <svg
              width="20"
              height="18"
              viewBox="0 0 20 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.51689 6.38124L7.25898 6.4178L2.88964 7.03726L2.88928 7.03731C2.50041 7.09215 2.38428 7.5307 2.63388 7.76704L2.63402 7.76718L5.79514 10.7627L5.9904 10.9477L5.9436 11.2126L5.196 15.4437C5.19599 15.4438 5.19598 15.4438 5.19597 15.4439C5.13918 15.7673 5.50476 16.077 5.8621 15.8928L5.86365 15.892L9.77243 13.894L10 13.7777L10.2276 13.894L14.1363 15.892L14.1364 15.892C14.4971 16.0764 14.8602 15.7646 14.8041 15.4441C14.8041 15.4441 14.8041 15.4441 14.8041 15.444C14.804 15.4439 14.804 15.4438 14.804 15.4437L14.0564 11.2126L14.0096 10.9477L14.2049 10.7627L17.366 7.76718L17.3661 7.76704C17.6157 7.5307 17.4996 7.09215 17.1107 7.03731L17.1104 7.03726L12.741 6.4178L12.4831 6.38124L12.3653 6.14891L10.4129 2.29933C10.4128 2.29922 10.4127 2.2991 10.4127 2.29899C10.2456 1.97198 9.75279 1.97343 9.58761 2.2984L7.51689 6.38124ZM7.51689 6.38124L7.63472 6.14891L9.58751 2.29859L7.51689 6.38124Z"
                stroke="#7E6947"
              />
            </svg>
          </li>
        );
      }
    };

    const LocationScoreList = (props) => {
      const transitType = props.type;
      const scores = ALL_SCORES[transitType] || [];
      const score = scores[props.score - 1];

      if (!score) return null;
      return (
        <div className="location_score">
          <h3 className="heading-6">{props.heading}</h3>
          <h4>{score.title}</h4>
          <p>{score.description}</p>
          <div className="stars-container">
            <ul>
              {Array.from(Array(scores.length), (_, index) => {
                const filled = score.stars < index + 1;
                return <Star key={index} filled={filled} />;
              })}
            </ul>
          </div>
        </div>
      );
    };

    if (!data.location_score) return null;
    return (
      <div className="template_no_data">
        <div className="template_pdf_label_title_details">
          <div className="template_location_score_title">Location Score</div>
          <div className="template_pdf_grid_layout">
            <LocationScoreList
              heading={"Walkability"}
              type={"walk"}
              score={data.location_score.walking_score}
            />
            <LocationScoreList
              heading={"Bike Friendly"}
              type={"bike"}
              score={data.location_score.bike_score}
            />
            <LocationScoreList
              heading={"Transit Friendly"}
              type={"transit"}
              score={data.location_score.commute_score}
            />
          </div>
        </div>
      </div>
    );
  };

  const Collections = ({ data }) => {
    if (!data.collections) return null;
    return (
      <div className="template_pdf_description_icon_container">
        <div className="feature_grid">
          <div className="property-info_features">
            <ul>
              {data.collections.map((collections, index) => (
                <li key={index}>
                  <img
                    src={
                      "/Assets/icons/categories/" + collections.slug + ".svg"
                    }
                    alt=""
                  />
                  {collections.name}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    );
  };

  const getDisplayPrice = () => {
    const PropTransactionType = listing.transaction_type;
    const PropSalePrice = parseInt(listing.sale_price);
    const PropLeasePrice = parseInt(listing.monthly_lease_price);

    return (
      <>
        {PropTransactionType === "sale"
          ? PropSalePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          : PropLeasePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
      </>
    );
  };

  return (
    <TemplatePDFstyle>
      <div className="containerPDF printable-component">
        <HeaderPDF />
        <PDFInfo
          data={{
            listing,
            type,
            title,
            address_line_1,
            address_line_2,
            bedroom_count,
            parking_space_count,
            lot_area,
            floor_area,
          }}
        />
        <hr className="template_pdf_divider" align={"left"} />
        <PropertyImages data={{ media }} />
        <PropertyDescription data={{ description }} />
        <Features
          data={{ transformedStructuralData, transformedAmenitiesData }}
        />
        <hr className="template_pdf_divider" align={"left"} />
        <LocationCoordinates data={{ latitude, longitude, location }} />

        <LocationScoreFunc data={{ location_score }} />
        <Collections data={{ collections }} />
        <div className="template_pdf_label_details_container" />
      </div>
    </TemplatePDFstyle>
  );
}

export default TemplatePDF;
